// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"e3f6392b","592":"67b6c9e8","600":"dee24d89","820":"f694d637"}[chunkId] + ".chunk.js";
};